import { Tooltip } from '@progress/kendo-react-tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import useStyles from '../../styles/useStyles';

export const InfoDataChangesCell: React.FC<any> = ({ props }) => {
    const classes = useStyles();
    return (
        <td className={props.className} style={{ textAlignLast: 'center' }}>
            <Tooltip
                position="top"
                parentTitle={true}
                anchorElement="target"
                content={() => <TooltipContentTemplate props={props.dataItem} />}
            >
                <div title="Info">
                    <FontAwesomeIcon icon={faInfoCircle} className={classes.baseFontAwesomeIcon} />
                </div>
            </Tooltip>
        </td>
    );
};

const TooltipContentTemplate: React.FC<any> = ({ props }) => {
    return (
        <>
            {props.createdBy && props.createdOn && (
                <p>
                    Created by <b>{props.createdBy}</b> on <b>{props.createdOn}</b>
                </p>
            )}
        </>
    );
};
